import Yup from '_zari/validation/_yup'

export const ValidationSchema = Yup.object().shape({
  _idSocio: Yup.string().required(),
  tipoDocumento: Yup.string().required(),
  tipoCambio: Yup.number().min(1).required(),
  moneda: Yup.string().required(),
  // Serie es opcional cuando el tipoDocumento es "00 - OTROS/TICKET" (se asigna
  // "ALM" por defecto al guardar).
  serieDocumento: Yup.string().when('tipoDocumento', {
    is: val => val && val !== '00',
    then: Yup.string().required(),
    otherwise: Yup.string()
  }),
  numeroDocumento: Yup.string().required(),
  fechaEmision: Yup.string().required(),
  fechaAlmacenamiento: Yup.string().required()
})
